export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher50_mob.6e2b63ca.png";